module.exports = __webpack_public_path__ + "img/ic-skt-5gx.b267831a.png";